<div #scrollTarget></div>
<div class="container-fluid mt-4">
  <h4 class="mb-3"><i class="fi fi-rr-newspaper"></i> სტატიები <span *ngIf="currentLang == 'en'">(EN)</span></h4>
  
  <div class="row mb-3">
    <div class="col-md-3">
      <!-- Dropdown list ტიპის მენიუებისთვის -->
      <select [(ngModel)]="selectedItem" class="form-select" (change)="onMenuChange()">
        <option *ngFor="let itm of selectedItems" [value]="itm.menu_page">
         {{ itm.menu?.title || itm.title }} 
        </option>
      </select>
    </div>
    <div class="col-md-3">
      <button class="btn btn-primary" (click)="openPost()">დამატება</button>
    </div>
    <div class="col-md-4">
      <input 
        type="text" 
        [(ngModel)]="search" 
        class="form-control" 
        placeholder="ძიება..." 
        (ngModelChange)="getPageByItems()" />
    </div>
  </div>

  <app-spinner [loading]="loaddata" text="იტვირთება..."></app-spinner>

  <div class="table-responsive" *ngIf="data?.items?.length">
    <table class="table table-bordered table-hover">
      <thead>
        <tr>
          <th>#</th>
          <th>სურათი</th>
          <th (click)="sortData('title')" style="cursor:pointer">სათაური
            <span *ngIf="sortColumn === 'title'">{{ sortDirection === 'asc' ? '↑' : '↓' }}</span>
          </th>
          <th (click)="sortData('postdate')" style="cursor:pointer">დამატების თარიღი
            <span *ngIf="sortColumn === 'postdate'">{{ sortDirection === 'asc' ? '↑' : '↓' }}</span>
          </th>
          <th (click)="sortData('visibility')" style="cursor:pointer">გამოჩენა
            <span *ngIf="sortColumn === 'visibility'">{{ sortDirection === 'asc' ? '↑' : '↓' }}</span>
          </th>
          <th>ქმედებები</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data.items; let i = index">
          <td>{{ (page - 1) * perPage + i + 1 }}</td>
          <td>
            <img *ngIf="item.main_image?.trim()" [src]="getFullImageUrl(item.main_image)" class="square-img" />
          </td>
          <td class="truncate-text">{{ item.title }}</td>
          <td>{{ item.date || item.date | date:'dd MMM yyyy, HH:mm' }}</td>
          <td>
            <span class="text-success" *ngIf="item.visible == 1">ჩანს</span>
            <span class="text-danger" *ngIf="item.visible == 0">არჩანს</span>
          </td>
          <td>
            <div class="d-flex">
              <button class="btn btn-sm border rounded mx-2" (click)="edit(item)">
                <i class="fi fi-rr-pencil"></i>
              </button>

              <!-- <a class="btn btn-sm border rounded mx-2" *ngIf="selectedMenuSource == 'pages'"
                 href="{{defaultDomain}}page/{{item.slug}}" target="_blank">
                <i class="fi fi-rr-eye text-info"></i>
              </a>

              <a class="btn btn-sm border rounded mx-2" *ngIf="selectedMenuSource == 'catalogs'" 
                 href="{{defaultDomain}}catalog/{{item.slug}}/{{item.id}}" target="_blank">
                <i class="fi fi-rr-eye text-info"></i>
              </a> -->

              <!-- <button class="btn btn-sm border rounded mx-2" (click)="delete(item, data?.source)">
                <i class="fi fi-rr-trash text-danger"></i>
              </button> -->
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Pagination -->
    <nav *ngIf="data?.pagination?.last_page > 1" class="mt-3">
      <ul class="pagination justify-content-center">
        <li class="page-item" [class.disabled]="page === 1">
          <button class="page-link" (click)="changePage(page - 1)" [disabled]="page === 1">&laquo;</button>
        </li>

        <li class="page-item" [class.active]="page === 1">
          <button class="page-link" (click)="changePage(1)">1</button>
        </li>

        <li class="page-item disabled" *ngIf="page > 4">
          <span class="page-link">...</span>
        </li>

        <ng-container *ngFor="let i of [].constructor(data.pagination.last_page); let idx = index">
          <ng-container *ngIf="idx + 1 > 1 && idx + 1 < data.pagination.last_page &&
                              idx + 1 >= page - 1 && idx + 1 <= page + 1">
            <li class="page-item" [class.active]="page === idx + 1">
              <button class="page-link" (click)="changePage(idx + 1)">{{ idx + 1 }}</button>
            </li>
          </ng-container>
        </ng-container>

        <li class="page-item disabled" *ngIf="page < data.pagination.last_page - 3">
          <span class="page-link">...</span>
        </li>

        <li class="page-item" [class.active]="page === data.pagination.last_page">
          <button class="page-link" (click)="changePage(data.pagination.last_page)">
            {{ data.pagination.last_page }}
          </button>
        </li>

        <li class="page-item" [class.disabled]="page === data.pagination.last_page">
          <button class="page-link" (click)="changePage(page + 1)" [disabled]="page === data.pagination.last_page">&raquo;</button>
        </li>
      </ul>
    </nav>
  </div>
</div>


